import React from 'react';
import Skeleton from 'react-loading-skeleton';

const Card = ({ 
  svgsrc,
  title='',
  subTitle = '',
  classes='',
  svgClasses='',
  subText,
  clickable=false,
  handler = () => {},
  titleClasses = '',
  subTitleClasses=''
}) => {

  return (
    <div className={'flex p-4 border-2 rounded-md ' + classes + `${clickable ? ' cursor-pointer hover:border-gray-300' : ''}`}
        onClick={handler}>
          <img src={svgsrc} className={'h-4 mr-1 mt-1 ' + svgClasses} />
          <div>
            <div className='font-semibold text-base text-gray-800 ml-2'>{title}</div>
            <div className='text-sm text-gray-600 ml-2'>{subTitle}</div>
            {subText && <div className='ml-2 text-gray-600 text-sm'>{subText}</div>}
          </div>
    </div>
  );
};

export default Card;